<template>
    <b-modal id="tripleaContactModal" hide-footer hide-header ref="tripleaContactModal">
        <div class="contact-modal-wrapper">
            <div class="contact-modal-image-bloc">
                <img src="@/assets/img/triplea/home/contact-modal-image.png"/>
            </div>
            <div class="contact-modal-content-bloc">
                <div class="contact-modal-content-title-row">
                    <h3>Fale conosco</h3>
                    <button class="modal-close-button" @click="closeModal">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.22259 4.22208C4.65216 3.79251 5.34865 3.79251 5.77822 4.22208L12.0004 10.4443L18.2226 4.22208C18.6522 3.79251 19.3486 3.79251 19.7782 4.22208C20.2078 4.65166 20.2078 5.34814 19.7782 5.77772L13.556 11.9999L19.7782 18.2221C20.2078 18.6517 20.2078 19.3482 19.7782 19.7777C19.3487 20.2073 18.6522 20.2073 18.2226 19.7777L12.0004 13.5555L5.77821 19.7777C5.34863 20.2073 4.65215 20.2073 4.22257 19.7777C3.793 19.3482 3.793 18.6517 4.22257 18.2221L10.4448 11.9999L4.22259 5.77772C3.79301 5.34814 3.79301 4.65166 4.22259 4.22208Z" fill="#333333"/>
                        </svg>
                    </button>
                </div>
                <div class="contact-modal-content-text-row">
                    <p>Saiba mais sobre as vantagens e a segurança que a Apolar Triple A pode oferecer.</p>
                    <p>Deixe seus dados abaixo e um de nossos especialistas do assunto entrará em contato.</p>
                </div>
                <div class="contact-modal-content-form-row">
                    <div class="contact-modal-content-form-line">
                        <label class="contact-modal-form-label">
                            <span>Nome</span>
                            <input class="contact-modal-form-input" placeholder="Nome"/>
                        </label>
                    </div>
                    <div class="contact-modal-content-form-line">
                        <label class="contact-modal-form-label">
                            <span>E-mail</span>
                            <input class="contact-modal-form-input" placeholder="E-mail"/>
                        </label>
                    </div>
                    <div class="contact-modal-content-form-line">
                        <label class="contact-modal-form-label">
                            <span>Telefone</span>
                            <input class="contact-modal-form-input" placeholder="Telefone"/>
                        </label>
                    </div>
                    <div class="contact-modal-form-button-line">
                        <button class="contact-modal-form-button">Enviar</button>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>
<script>
  import "@/assets/scss/custom/triplea/components/_home_contact_modal.scss"
  export default {
    data() {
        return {
        selectedValue: 'parcela',
        };
    },
    methods: {
        selectValue(value) {
            this.selectedValue = value;
        },
        closeModal() {
            this.$refs.tripleaContactModal.hide();
        },
    } 
  }
</script>
